module.exports = __webpack_public_path__ + "img/btn_go2.85a99682.png";